import { ApolloProvider } from "@apollo/client"
import React from "react"
import useClient from "./client"
// import useClient from "./apollo.client";
const ApolloClientProvider = ({ children }) => {
  const apolloClient = useClient()
  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>
}

export default ApolloClientProvider
